import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }
const _hoisted_11 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_12 = { class: "control-label col-sm-6" }
const _hoisted_13 = { class: "col-sm" }
const _hoisted_14 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_15 = { class: "control-label col-sm-6" }
const _hoisted_16 = { class: "col-sm" }
const _hoisted_17 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_18 = { class: "control-label col-sm-6" }
const _hoisted_19 = { class: "col-sm" }
const _hoisted_20 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_21 = { class: "control-label col-sm-6" }
const _hoisted_22 = { class: "col-sm" }
const _hoisted_23 = {
  key: 2,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_24 = { class: "control-label col-sm-6" }
const _hoisted_25 = { class: "col-sm" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_28 = { class: "control-label col-sm-6" }
const _hoisted_29 = { class: "col-sm" }
const _hoisted_30 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_31 = { class: "control-label col-sm-6" }
const _hoisted_32 = { class: "col-sm" }
const _hoisted_33 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_34 = { class: "control-label col-sm-6" }
const _hoisted_35 = { class: "col-sm" }
const _hoisted_36 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_37 = { class: "control-label col-sm-6" }
const _hoisted_38 = { class: "col-sm" }
const _hoisted_39 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_40 = { class: "control-label col-sm-6" }
const _hoisted_41 = { class: "col-sm" }
const _hoisted_42 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_43 = { class: "control-label col-sm-6" }
const _hoisted_44 = { class: "col-sm" }
const _hoisted_45 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_46 = { class: "control-label col-sm-6" }
const _hoisted_47 = { class: "col-sm" }
const _hoisted_48 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_49 = { class: "control-label col-sm-6" }
const _hoisted_50 = { class: "col-sm" }
const _hoisted_51 = {
  key: 2,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_52 = { class: "control-label col-sm-6" }
const _hoisted_53 = { class: "col-sm" }

import { watch , ref, inject} from 'vue'
import { usePreventivo } from '../../composable/usePreventivo';
import FormSocietarioHelper from "../../pages/preventivi/json/societario/helper.json";
import DettaglioPreventivoHelper from "./../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormSocietarioCostituzioni',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo', 'infoCompilazione'],
  setup(__props, { emit: __emit }) {

const {
  categorieValidazione
} = usePreventivo();
const props = __props;
const emits = __emit;
let validazione;
const { regimeFiscale } = inject('regimeFiscale')
const validazioneEquoCompenso = ref();
switch (props.formName) {
  case 'costituzioneSocieta':
    validazione = categorieValidazione.categoriaSocietario['sottocategoriaCostituzione']['costituzioneSocieta'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaSocietario['sottocategoriaCostituzione']['costituzioneSocieta'];
    break
  case 'costituzioneSocietaConConferimenti':
    validazione  = categorieValidazione.categoriaSocietario['sottocategoriaCostituzione']['costituzioneSocietaConConferimenti'];
    validazioneEquoCompenso.value  = categorieValidazione.categoriaSocietario['sottocategoriaCostituzione']['costituzioneSocietaConConferimenti'];
    break
}
const testoInfoCompilazione = ref([]);
testoInfoCompilazione.value =  FormSocietarioHelper.sottocategoriaCostituzione[props.formName];
emits('infoCompilazione',  testoInfoCompilazione);
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
if(validazione){
  validazione.tipo_preventivo.value = 'societario/costituzioni/' + props.tipoPreventivo.data.url
}
function tipoSocieta(event){
  if(event.target.value == 'societa_di_capitali' || event.target.value == 'startup_innovativa'){
    validazione.forma_del_titolo.value = 'pubblico';
  } else if(event.target.value == 'societa_di_persone'){
    validazione.forma_del_titolo.value = 'pubblico';
    validazione.semplificata.value = '';
  }
}
function tipoConferimento(event){
  let value = event.target.value;
  if (value === 'c_immobile_da_soggetto_privato_non_agricolo_non_commerciale' ||
      value === 'c_da_soggetto_privato_di_immobile_destinato_ad_attivita_commerciale' ||
      value === 'c_di_terreno_agricolo' ||
      value === 'c_di_terreno_agricolo_in_societa_agricola') {
    validazione.valore_conferimento.required = true;
  } else {
    validazione.valore_conferimento.required = false;
  }
}
watch(validazione, (newValue, oldValue) => {
  emits('changeDatiPreventivo')
}, { deep: true });
let indexHelperClosing = {
  calcolo: FormSocietarioHelper.sottocategoriaCostituzione[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'costituzioneSocieta')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).tipo_societa.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_societa.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_select, {
                name: "tipo_societa",
                options: [{name: 'Società di capitali', value: 'societa_di_capitali'},
                       {name: 'Società di persone', value: 'societa_di_persone'},
                       {name: 'Startup innovativa', value: 'startup_innovativa'}
                       ],
                isSelected: _unref(validazione).tipo_societa.value != '',
                onChange: _cache[0] || (_cache[0] = $event => (tipoSocieta($event))),
                state: __props.readonly == true ?'disable':'',
                validateTo: _unref(validazione).tipo_societa,
                "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).tipo_societa) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(validazione).valore_capitale.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_capitale.ref]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_input_text, {
                id: "valore_capitale",
                name: "valore_capitale",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).valore_capitale,
                "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).valore_capitale) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
              _createTextVNode(_toDisplayString(_unref(validazione).diritto_annuale_registro_imprese.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.diritto_annuale_registro_imprese.ref]
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_base_select, {
                name: "diritto_annuale_registro_imprese",
                options: [{name: 'Versato dal notaio', value: 'versato_dal_notaio'},
                       {name: 'Versato dall\'azienda', value: 'versato_dall_azienda'}],
                isSelected: _unref(validazione).diritto_annuale_registro_imprese.value != '',
                state: __props.readonly == true ?'disable':'',
                validateTo: _unref(validazione).diritto_annuale_registro_imprese,
                "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).diritto_annuale_registro_imprese) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_12, [
              _createTextVNode(_toDisplayString(_unref(validazione).tassa_concessione_governativa.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tassa_concessione_governativa.ref]
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_base_select, {
                name: "tassa_concessione_governativa",
                options: [{name: 'Versato dal notaio', value: 'versato_dal_notaio'},
                       {name: 'Versato dall\'azienda', value: 'versato_dall_azienda'}],
                isSelected: _unref(validazione).tassa_concessione_governativa.value != '',
                state: __props.readonly == true ?'disable':'',
                validateTo: _unref(validazione).tassa_concessione_governativa,
                "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).tassa_concessione_governativa) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_15, [
              _createTextVNode(_toDisplayString(_unref(validazione).comunicazione_socio_unico.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.comunicazione_socio_unico.ref]
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_base_input_checkbox, {
                class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                name: "comunicazione_socio_unico",
                label: "Sì",
                "validate-to": _unref(validazione).comunicazione_socio_unico,
                "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).comunicazione_socio_unico) = $event))
              }, null, 8 /* PROPS */, ["class", "validate-to"])
            ])
          ]),
          (_unref(validazione).tipo_societa.value != 'societa_di_capitali' && _unref(validazione).tipo_societa.value != 'startup_innovativa')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_18, [
                  _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_base_select, {
                    name: "forma_del_titolo",
                    options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                    isSelected: _unref(validazione).forma_del_titolo.value != '',
                    state: __props.readonly == true ?'disable':'',
                    validateTo: _unref(validazione).forma_del_titolo,
                    "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).tipo_societa.value != 'societa_di_persone')
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_21, [
                  _createTextVNode(_toDisplayString(_unref(validazione).semplificata.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.semplificata.ref]
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "semplificata",
                    label: "Sì, è semplificata",
                    "validate-to": _unref(validazione).semplificata,
                    "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).semplificata) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(regimeFiscale) == 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_24, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "valore_capitale",
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : (__props.formName === 'costituzioneSocietaConConferimenti')
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_28, [
                _createTextVNode(_toDisplayString(_unref(validazione).tipo_societa.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_societa.ref]
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_base_select, {
                  name: "tipo_societa",
                  options: [{name: 'Società di capitali', value: 'societa_di_capitali'},
                       {name: 'Società di persone', value: 'societa_di_persone'}],
                  isSelected: _unref(validazione).tipo_societa.value != '',
                  onChange: _cache[9] || (_cache[9] = $event => (tipoSocieta($event))),
                  state: __props.readonly == true ?'disable':'',
                  validateTo: _unref(validazione).tipo_societa,
                  "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).tipo_societa) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_31, [
                _createTextVNode(_toDisplayString(_unref(validazione).valore_capitale.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_capitale.ref]
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_base_input_text, {
                  id: "valore_capitale",
                  name: "valore_capitale",
                  class: "placeholder-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).valore_capitale,
                  "onUpdate:validateTo": _cache[11] || (_cache[11] = $event => ((_unref(validazione).valore_capitale) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_34, [
                _createTextVNode(_toDisplayString(_unref(validazione).diritto_annuale_registro_imprese.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.diritto_annuale_registro_imprese.ref]
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_base_select, {
                  name: "diritto_annuale_registro_imprese",
                  options: [{name: 'Versato dal notaio', value: 'versato_dal_notaio'},
                       {name: 'Versato dall\'azienda', value: 'versato_dall_azienda'}],
                  isSelected: _unref(validazione).diritto_annuale_registro_imprese.value != '',
                  state: __props.readonly == true ?'disable':'',
                  validateTo: _unref(validazione).diritto_annuale_registro_imprese,
                  "onUpdate:validateTo": _cache[12] || (_cache[12] = $event => ((_unref(validazione).diritto_annuale_registro_imprese) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_37, [
                _createTextVNode(_toDisplayString(_unref(validazione).tassa_concessione_governativa.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tassa_concessione_governativa.ref]
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_base_select, {
                  name: "tassa_concessione_governativa",
                  options: [{name: 'Versato dal notaio', value: 'versato_dal_notaio'},
                       {name: 'Versato dall\'azienda', value: 'versato_dall_azienda'}],
                  isSelected: _unref(validazione).tassa_concessione_governativa.value != '',
                  state: __props.readonly == true ?'disable':'',
                  validateTo: _unref(validazione).tassa_concessione_governativa,
                  "onUpdate:validateTo": _cache[13] || (_cache[13] = $event => ((_unref(validazione).tassa_concessione_governativa) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_40, [
                _createTextVNode(_toDisplayString(_unref(validazione).comunicazione_socio_unico.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.comunicazione_socio_unico.ref]
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_base_input_checkbox, {
                  class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                  name: "comunicazione_socio_unico",
                  label: "Sì",
                  "validate-to": _unref(validazione).comunicazione_socio_unico,
                  "onUpdate:validateTo": _cache[14] || (_cache[14] = $event => ((_unref(validazione).comunicazione_socio_unico) = $event))
                }, null, 8 /* PROPS */, ["class", "validate-to"])
              ])
            ]),
            (_unref(validazione).tipo_societa.value != 'societa_di_capitali')
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_43, [
                    _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_base_select, {
                      name: "forma_del_titolo",
                      options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                      isSelected: _unref(validazione).forma_del_titolo.value != '',
                      state: __props.readonly == true ?'disable':'',
                      validateTo: _unref(validazione).forma_del_titolo,
                      "onUpdate:validateTo": _cache[15] || (_cache[15] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                    }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_45, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_46, [
                _createTextVNode(_toDisplayString(_unref(validazione).tipo_conferimento.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_conferimento.ref]
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_base_select, {
                  name: "tipo_conferimento",
                  options: [
                {name: 'Conferimento d\'azienda senza immobili', value: 'c_azienda_senza_immobili'},
                {name: 'Conferimento d\'azienda con immobili', value: 'c_azienda_con_immobili'},
                {name: 'Conferimento di quote sociali', value: 'c_quote_sociali'},
                {name: 'Conferimento di bene abitativo a IVA da parte di soggetto passivo IVA', value: 'c_bene_abitativo_a_iva_da_soggetto_passivo_iva'},
                {name: 'Conferimento di fabbricato strumentale da parte di soggetto IVA', value: 'c_fabbricato_strumentale_da_soggetto_iva'},
                {name: 'Conferimento di terreno edificabile da parte di soggetto passivo IVA', value: 'c_terreno_edificabile_da_soggetto_passivo_iva'},
                {name: 'Conferimento di immobile da soggetto privato non agricolo e non commerciale', value: 'c_immobile_da_soggetto_privato_non_agricolo_non_commerciale'},
                {name: 'Conferimento da parte di soggetto privato di immobile destinato ad attività commerciale', value: 'c_da_soggetto_privato_di_immobile_destinato_ad_attivita_commerciale'},
                {name: 'Conferimento di terreno agricolo', value: 'c_di_terreno_agricolo'},
                {name: 'Conferimento di terreno agricolo in società agricola', value: 'c_di_terreno_agricolo_in_societa_agricola'}
                ],
                  onChange: _cache[16] || (_cache[16] = $event => (tipoConferimento($event))),
                  state: __props.readonly == true ?'disable':'',
                  isSelected: _unref(validazione).tipo_conferimento.value != '',
                  validateTo: _unref(validazione).tipo_conferimento,
                  "onUpdate:validateTo": _cache[17] || (_cache[17] = $event => ((_unref(validazione).tipo_conferimento) = $event))
                }, null, 8 /* PROPS */, ["state", "isSelected", "validateTo"])
              ])
            ]),
            (_unref(validazione).tipo_conferimento.value == 'c_immobile_da_soggetto_privato_non_agricolo_non_commerciale' ||
               _unref(validazione).tipo_conferimento.value == 'c_da_soggetto_privato_di_immobile_destinato_ad_attivita_commerciale' ||
               _unref(validazione).tipo_conferimento.value == 'c_di_terreno_agricolo' ||
               _unref(validazione).tipo_conferimento.value == 'c_di_terreno_agricolo_in_societa_agricola')
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_49, [
                    _createTextVNode(_toDisplayString(_unref(validazione).valore_conferimento.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_conferimento.ref]
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_base_input_text, {
                      id: "valore_conferimento",
                      name: "valore_conferimento",
                      class: "placeholder-right",
                      placeholder: "0,00",
                      disabled: __props.readonly,
                      "validate-to": _unref(validazione).valore_conferimento,
                      "onUpdate:validateTo": _cache[18] || (_cache[18] = $event => ((_unref(validazione).valore_conferimento) = $event))
                    }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (_unref(regimeFiscale) == 'ordinario')
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_52, [
                    _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_base_input_checkbox, {
                      class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                      name: "ritenuta_acconto",
                      label: "Si, applicabile",
                      "validate-to": _unref(validazione).ritenuta_acconto,
                      "onUpdate:validateTo": _cache[19] || (_cache[19] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                    }, null, 8 /* PROPS */, ["class", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(CalcoloEquoCompenso, {
              "input-riferimento-calcolo": "valore_capitale",
              validazione: validazioneEquoCompenso.value,
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
          ]))
        : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}